import Vue from "vue";

export async function fetchBirths({ commit }) {
  try {
    const { data } = await Vue.axios({
      url: "/frontend/births"
    });
    commit("births/setBirths", data, { root: true });
  } catch (e) {
    commit("birthsError", e.message);
  } finally {
    // console.log("La petición para obtener los births ha finalizado");
  }
}

export async function addBirth({ commit }, birth, formData) {
  try {
    await Vue.axios({
      method: "POST",
      url: "/frontend/births",
      data: {
        child_name: birth.child_name,
        child_lastname: birth.child_lastname,
        birthday: birth.birthday,
        full_name_mother: birth.full_name_mother,
        full_name_father: birth.full_name_father,
        gender: birth.gender,
        approved: false,
        show_birth: birth.show_birth,
        user_id: birth.user_id,
        images: formData,
      }
    });
  } catch (e) {
    commit("birthsError", e.message);
  } finally {
    // console.log("La petición para crear el nacimiento ha finalizado");
  }
}

export async function updateBirth({ commit }, birth) {
  try {
    await Vue.axios({
      method: "PUT",
      url: `/frontend/births/${birth.id}`,
      data: {
        id: birth.id,
        child_name: birth.child_name,
        child_lastname: birth.child_lastname,
        gender: birth.gender,
        birthday: birth.birthday,
        full_name_mother: birth.full_name_mother,
        full_name_father: birth.full_name_father,
        approved: true
      }
    });
  } catch (e) {
    commit("birthsError", e.message);
  } finally {
    // console.log("La petición para actualizar el nacimiento ha finalizado");
  }
}

export async function removeBirth({ commit, dispatch }, id) {
  try {
    await Vue.axios({
      method: "DELETE",
      url: `/frontend/births/${id}`
    });
    dispatch("fetchBirths");
  } catch (e) {
    commit("birthsError", e.message);
  } finally {
    // console.log("La petición para eliminar el nacimiento ha finalizado");
  }
}
